<template>
    <section class="mt-2" v-if="!!errors && typeof errors === 'object'">
        <div v-for="f in Object.keys(errors)" class="alert alert-danger">
            <a href="#" class="close" data-dismiss="alert">&times;</a>
            <strong>Error!</strong>
            <!-- <span class="text-capitalize">{{f.replace(/\s+/g,' ')}}</span>: -->
            <span class="comma-list" v-for="e in errors[f]">{{ e }}</span>
        </div>
    </section>
</template>

<script>
export default {
    name: "ErrorList",
    props: ["errors"],
};
</script>
